import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Grid,
  Card,
  Box,
  AlertColor,
  autocompleteClasses,
  Tooltip,
  Popover,
} from '@mui/material';
import '../layouts/header/DashboardHeadercomponent.css';
import Textinput from '../components/formlib/Textinput';
import DurationPicker from '../components/formlib/DurationPicker';
import SwitchComponent from '../components/formlib/SwitchComponent';
import DatePickerComponent from '../components/formlib/DatePickerComponent';
import RadioComponent from '../components/formlib/RadioComponent';
import SelectComponent from '../components/formlib/SelectComponent';
import * as yup from 'yup';
import { Formik, FormikErrors, FormikProps } from 'formik';
import dayjs, { Dayjs } from 'dayjs';
import { PaletteColorOptions } from '@mui/material/styles';
import MediumTypography from '../components/formlib/MediumTypography';
import CommentTextbox from '../components/formlib/CommentTextbox';
import CheckBoxComponent from '../components/formlib/CheckBoxComponent';
import {
  AddNewClient,
  DPHValues,
  FaceSheetDemographicsType,
  OptionType,
  ZipCodeType,
} from '../utils/type';
import {
  deleteClientProfilePicture,
  getZipCodeDetails,
  updateClientdata,
  uploadProfilePic,
  viewClientDetails,
  ZipCodeResponse,
} from '../services/configApi/User';
import SnackBarComponent from '../components/formlib/SnackBarComponent';
import ButtonComponent from '../components/formlib/ButtonComponent';
import ModalPopup from '../components/formlib/ModalPopup';
import { TabProps } from '../components/formlib/TabNavigationComponent';
import { Gender, primaryResidenceValues } from './Dropdown';
import AlertDialogSlide from '../components/formlib/AlertDialogSlide';
import './ClientsDashboardPage.css';
import AddressForm from '../components/formlib/AddressForm';
import ImagePicker from '../components/imagepickers/ImagePicker';
import { ImagePickerConf } from '../components/imagepickers/imagepicker.models';
import { dataURItoFile } from '../utils/fileUtils';
import { useIntl } from 'react-intl';
import {
  calculateMonths,
  datePickerMinDateMaxDateValidate,
  threeYearsAgo,
  formatToDurationFromDecimal,
  formatToDecimalFromDuration,
} from '../utils/dateUtil';
import { formatNumberToDecimal } from '../utils/utilities';
import {
  ApiError,
  ApiMessage,
  isCustomError,
} from '../services/ApiResponseHandler';
import _, { debounce } from 'lodash';
import {
  convertGenderToBackend,
  convertGenderToFrontend,
} from '../utils/genderUtil';
import { checkPermissionForFeature } from '../utils/checkPermission';
import { LookUpContext } from '../context/LookUpContextProvider';
import MultipleAutocompleteSearch from '../components/formlib/MultipleAutocompleteSearch';
import DropdownComponent from '../components/formlib/DropdownComponent';
import CustomRadioButton from '../components/formlib/CustomRadioButton';
import { EICSRadioData } from './intake/IntakeClientsInfo';
import { IntakeRadioData } from './intake/IntakePregnancyInfo';
import { LoaderContext, LoaderContextType } from '../layouts/AppSidebar';
import AutocompleteSearch from '../components/formlib/AutocompleteSearch';
import {
  DiagnosisCode,
  getCodesAndDescriptionNew,
} from '../services/configApi/codelist/diagnosticCodes';
import SimilarClientsUpdateModal from './referral/SimilarClientsUpdateModal';
import { SimilarClient } from './referral/type';
import { nameValidation as suffixValidation } from '../utils/formValidationUtil';
import { Address } from './employees/types';
import { formatName } from '../utils/nameUtils';
import { UnSavedChangesContext } from '../context/UnSavedChangesProvider';
import { DiagnosisOptionType } from './faceSheet/FaceSheetScreen';
import { ReactComponent as InfoIcon } from '../assets/images/infoIcon.svg';
import { useMultiplePermissions } from '../hooks/usePermissions';
import { REFERRAL_STATUS_KEY } from '../services/Constant';

declare module '@mui/material/styles' {
  interface CustomPalette {
    pink: PaletteColorOptions;
    normal: PaletteColorOptions;
  }
  interface PaletteOptions extends CustomPalette {
    pink: PaletteColorOptions;
    normal: PaletteColorOptions;
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    pink: true;
    normal: true;
  }
}
interface AddressProps {
  updateData: (
    newData: AddNewClient,
    tabposition: number,
    flag: boolean,
  ) => void;
  setTabProp: React.Dispatch<React.SetStateAction<TabProps>>;
}

type ClientPageFormValues = AddNewClient & {
  assessmentHoursDecDisplay: string | null;
  assessmentHrsUsedPriorProgramDecDisplay: string | null;
  noOfAssessmentHoursUsedDecDisplay: string | null;
  remainingAssessmentHoursDecDisplay: string | null;
};

const toAddNewClient = (values: ClientPageFormValues): AddNewClient => {
  const {
    assessmentHoursDecDisplay,
    assessmentHrsUsedPriorProgramDecDisplay,
    noOfAssessmentHoursUsedDecDisplay,
    remainingAssessmentHoursDecDisplay,
    ...rest
  } = values;
  return rest as AddNewClient;
};

const intialState: AddNewClient = {
  id: 0,
  firstName: '',
  middleName: '',
  lastName: '',
  nickName: '',
  suffix: null,
  nickNameWithheldIndicator: false,
  dateOfBirth: null,
  sex: '',
  race: '',
  ethnicity: '',
  multipleBirth: '',
  childBorn: '',
  childAdopted: '',
  mothersResidenceInMACode: '',
  mothersCommunityCode: { id: '', label: '' },
  primaryResidence: '',
  primarySpokenLanguage: '',
  primarySpokenLanguageOther: '',
  primaryWrittenLanguage: '',
  primaryWrittenLanguageOther: '',
  languageForPriorWrittenNotice: '',
  languageForPriorWrittenNoticeOther: '',
  smokingInTheHouse: null,
  petsInTheHouse: null,
  weapons: null,
  weaponSecure: null,
  street: '',
  address2: '',
  zipCode: '',
  city: { id: '', label: '' },
  state: '',
  dphId: null,
  mailingAddressFlag: false,
  mStreet: '',
  mAddress2: '',
  mCity: { id: '', label: '' },
  mZipCode: '',
  mState: '',
  remainingAssessmentHoursDec: null,
  assessmentHrsUsedPriorProgramDec: null,
  assessmentHoursDec: null,
  noOfAssessmentHoursUsedDec: null,
  rollOverDate: null,
  beginDate: null,
  visitDate: null,
  evaluationAddressFlag: false,
  eState: '',
  eStreet: '',
  eAddress2: '',
  eZipCode: '',
  eCity: { id: '', label: '' },
  enterNote: '',
  referralDate: null,
  ifspDueDate: null,
  clientId: '',
  clientUuid: '',
  appSource: '',
  version: 0,
  referralId: '',
  profileImageUrl: null,
  evaluationStatus: false,
  consentToShare: false,
  billingDiagnosisCode: null,
  similarClients: [],
  assessmentBeginDateUpdatedBy: null,
  dobChanged: false,
  nameChanged: false,
};

const validationSchema = yup.object().shape({
  firstName: yup.string().required('Clientpage.First.validation'),
  middleName: yup.string(),
  lastName: yup.string().required('Clientpage.last.validation').nullable(),
  nickName: yup.string().nullable(),
  suffix: yup.string().nullable(),
  nickNameWithheldIndicator: yup.boolean().nullable(),
  multipleBirth: yup.string().nullable(),
  childBorn: yup.string().nullable(),
  childAdopted: yup.string().nullable(),
  mothersResidenceInMACode: yup.string().nullable(),
  mothersCommunityCode: yup
    .object()
    .nullable()
    .when('mothersResidenceInMACode', {
      is: 'YES',
      then: yup.object().shape({
        label: yup
          .string()
          .required('motherResidenceAtTimeOfChildBirthInMARequired'),
      }),
    }),
  dateOfBirth: yup
    .date()
    .required('Clientpage.dateOfBirth.validation')
    .nullable(),
  consentToShare: yup.boolean().default(false),
  billingDiagnosisCode: yup.string().nullable(),
  sex: yup.string().required('Clientpage.Gender.validation').nullable(),
  race: yup.string().nullable(),
  ethnicity: yup.string().nullable(),
  primarySpokenLanguage: yup.string().nullable(),
  primarySpokenLanguageOther: yup.string().when('primarySpokenLanguage', {
    is: 'OTHER',
    then: yup
      .string()
      .required('Clientpage.PrimarySpoken.validation')
      .nullable(),
    otherwise: yup.string().nullable(),
  }),
  primaryWrittenLanguage: yup.string().nullable(),
  primaryWrittenLanguageOther: yup.string().when('primaryWrittenLanguage', {
    is: 'OTHER',
    then: yup
      .string()
      .required('Clientpage.PrimaryWritten.validation')
      .nullable(),
    otherwise: yup.string().nullable(),
  }),
  languageForPriorWrittenNotice: yup.string().nullable(),
  languageForPriorWrittenNoticeOther: yup
    .string()
    .when('languageForPriorWrittenNotice', {
      is: 'OTHER',
      then: yup
        .string()
        .required('Clientpage.PriorNotice.validation')
        .nullable(),
      otherwise: yup.string().nullable(),
    }),
  smokingInTheHouse: yup.boolean().nullable(),
  petsInTheHouse: yup.boolean().nullable(),
  weapons: yup.boolean().nullable(),
  weaponSecure: yup.boolean().when('weapons', {
    is: true,
    then: yup.boolean().nullable(),
    otherwise: yup.boolean().nullable(),
  }),
  enterNote: yup.string().nullable(),
  referralDate: yup.date().notRequired().nullable(),
  ifspDueDate: yup.date().notRequired().nullable(),
  street: yup.string().required('addressLine1RequiredMessage').nullable(),
  address2: yup.string().nullable(),
  state: yup.string().required('stateRequiredMessage').nullable(),
  zipCode: yup
    .string()
    .min(5, 'validZipCodeErrorMessage')
    .required('zipCodeRequiredMessage')
    .nullable(),
  city: yup
    .object()
    .shape({
      label: yup.string().required('cityRequiredMessage'),
    })
    .nullable(),
  mailingAddressFlag: yup.boolean().nullable(),
  mStreet: yup.string().when('mailingAddressFlag', {
    is: true,
    then: yup.string().required('addressLine1RequiredMessage'),
    otherwise: yup.string().nullable(),
  }),
  mAddress2: yup.string().when('mailingAddressFlag', {
    is: true,
    then: yup.string().nullable(),
    otherwise: yup.string().nullable(),
  }),
  mZipCode: yup.string().when('mailingAddressFlag', {
    is: true,
    then: yup
      .string()
      .min(5, 'validZipCodeErrorMessage')
      .required('zipCodeRequiredMessage'),
    otherwise: yup.string().nullable(),
  }),
  mCity: yup.object().when('mailingAddressFlag', {
    is: true,
    then: yup.object().shape({
      label: yup.string().required('cityRequiredMessage'),
    }),
    otherwise: yup.object().nullable(),
  }),
  mState: yup.string().when('mailingAddressFlag', {
    is: true,
    then: yup.string().required('Clientpage.State.validation'),
    otherwise: yup.string().nullable(),
  }),
  eStreet: yup.string().required('addressLine1RequiredMessage').nullable(),
  eAddress2: yup.string().nullable(),
  eState: yup.string().required('Clientpage.State.validation').nullable(),
  eZipCode: yup
    .string()
    .min(5, 'validZipCodeErrorMessage')
    .required('zipCodeRequiredMessage')
    .nullable(),
  eCity: yup
    .object()
    .shape({
      label: yup.string().required('cityRequiredMessage'),
    })
    .nullable(),
  visitDate: yup
    .date()
    .nullable()
    .test(
      'visitDate-required-if-beginDate',
      'First Assesment Visit date is required',
      function (value) {
        const { beginDate } = this.parent;
        if (beginDate && !value) return false;
        return true;
      },
    ),

  beginDate: yup
    .date()
    .nullable()
    .test(
      'beginDate-required-if-visitDate',
      'Assessment Begin date is required',
      function (value) {
        const { visitDate } = this.parent;
        if (visitDate && !value) return false;
        return true;
      },
    ),
  assessmentHoursDec: yup
    .number()
    .nullable()
    .min(0, 'Clientpage.assessmentHoursInvalid')
    .max(10, 'Clientpage.assessmentHoursInvalid'),
  assessmentHrsUsedPriorProgramDec: yup
    .number()
    .nullable()
    .min(0, 'Clientpage.assessmentHrsUsedPriorProgramInvalid')
    .max(10, 'Clientpage.assessmentHrsUsedPriorProgramInvalid'),
  noOfAssessmentHoursUsedDec: yup
    .number()
    .nullable()
    .min(0, 'Clientpage.noOfAssessmentHoursUsedInvalid')
    .max(20, 'Clientpage.noOfAssessmentHoursUsedInvalid'),
  remainingAssessmentHoursDec: yup
    .number()
    .nullable()
    .min(0, 'Clientpage.remainingAssessmentHoursInvalid')
    .max(20, 'Clientpage.remainingAssessmentHoursInvalid'),
  assessmentHoursDecDisplay: yup.string().nullable(),
  assessmentHrsUsedPriorProgramDecDisplay: yup.string().nullable(),
  noOfAssessmentHoursUsedDecDisplay: yup.string().nullable(),
  remainingAssessmentHoursDecDisplay: yup.string().nullable(),
});

const config: ImagePickerConf = {
  borderRadius: '100%',
  language: 'en',
  objectFit: 'cover',
  aspectRatio: 1,
  compressInitial: null,
  hideDownloadBtn: true,
  hideAddBtn: true,
  hideEditBtn: true,
  hideDeleteBtn: true,
  type: 'ProfilePicture',
};

interface UnsavedChangesWatcherProps {
  values: AddNewClient;
  initialValues: AddNewClient;
  onUnsavedChangesChange: (hasUnsavedChanges: boolean) => void;
}

const UnsavedChangesWatcher = ({
  values,
  initialValues,
  onUnsavedChangesChange,
}: UnsavedChangesWatcherProps) => {
  React.useEffect(() => {
    if (!_.isEqual(initialValues, values)) {
      onUnsavedChangesChange(true);
    } else {
      onUnsavedChangesChange(false);
    }
  }, [values]);

  return null;
};

const ClientPage: React.FC<AddressProps> = ({ updateData }: AddressProps) => {
  const [imageSrc, setImageSrc] = React.useState<string | null>('');
  const location = useLocation();
  const rctl = useIntl();
  const { toggleLoader } = React.useContext(LoaderContext) as LoaderContextType;
  const [open, setOpen] = React.useState(false);
  const [toastrVariable, setToastrVariable] =
    React.useState<AlertColor>('info');
  const [clientDetails, setClientDetails] =
    React.useState<AddNewClient>(intialState);
  const [renderView, setrenderView] = React.useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const [weaponAlert, setWeaponAlert] = React.useState(false);
  const formRef = React.useRef<FormikProps<ClientPageFormValues>>(null);
  const [toastrDefaultMessage, setToastrDefaultMessage] = React.useState('');
  const [toastrId, setToastrId] = React.useState('');
  const [btnloader, setBtnloader] = React.useState(false);
  const [mailingAddressCheckBox, setMailingAddressCheckBox] =
    React.useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [raceValues, setRaceValues] = React.useState<OptionType[]>([]);
  const [ethnicityValues, setEthnicityValues] = React.useState<OptionType[]>(
    [],
  );
  const [languageValues, setLanguageValues] = React.useState<OptionType[]>([]);
  const [selectedDiagnosisCodesList, setSelectedDiagnosisCodesList] =
    React.useState<OptionType | null>(null);
  const [diagnosisCodesList, setDiagnosisCodesList] = React.useState<
    OptionType[]
  >([]);
  const { lookups } = React.useContext(LookUpContext);
  const [showSimilarClientsModal, setShowSimilarClientsModal] =
    React.useState<boolean>(false);
  const [similarClients, setSimilarClients] = React.useState<SimilarClient[]>(
    [],
  );
  const [isEvalAddressChanged, setIsEvalAddressChanged] = React.useState(false);
  const [evalAddress, setEvalAddress] = React.useState<Address>();
  const [zipCodeOptions, setZipCodeOptions] = React.useState<OptionType[]>([]);
  const [zipCodes, setZipCodes] = React.useState<ZipCodeType[]>([]);
  const parentRef = React.useRef<HTMLDivElement>(null);

  const { updateDemographics } = React.useContext(LookUpContext);
  const { handleUpdateUnsavedChanges } = React.useContext(
    UnSavedChangesContext,
  );

  const changeTextDebouncer = React.useCallback(
    debounce((code: string) => fetchZipCodeDetail(code), 500),
    [],
  );
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const motherResidencePopover = Boolean(anchorEl);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const fetchZipCodeDetail = (city: string) => {
    getZipCodeDetails(city, true)
      .then((response: ZipCodeResponse) => {
        setZipCodes(response.zipcodes);
        const codes: OptionType[] = [];
        response.zipcodes.forEach((code) => {
          codes.push({
            id: code.zipCode,
            label: `${code.city} - ${code.state}`,
          });
        });
        setZipCodeOptions(codes);
      })
      .catch(() => {
        const codes: OptionType[] = [];
        setZipCodeOptions(codes);
      });
  };

  React.useEffect(() => {
    const handleDiagnosisDataGetAPI = async () => {
      toggleLoader(true);
      getCodesAndDescriptionNew()
        .then((response: DiagnosisCode[]) => {
          const diagnosisCodeList: DiagnosisOptionType[] = [];
          if (response.length > 0) {
            response.forEach((codeDetails) => {
              if (!codeDetails.isDeleted) {
                diagnosisCodeList.push({
                  id: codeDetails.code,
                  label: codeDetails.oneYearEligibility
                    ? `${codeDetails.code} - * ${codeDetails.description}`
                    : `${codeDetails.code} - ${codeDetails.description}`,
                  isDeleted: codeDetails.isDeleted
                    ? codeDetails.isDeleted
                    : false,
                });
              }
            });
            const soertedLIst = [...diagnosisCodeList];
            soertedLIst.sort((a, b) => {
              if (a.id < b.id) return -1;
              if (a.id > b.id) return 1;
              return 0;
            });

            const clientId = localStorage.getItem('ClientId');
            if (clientId !== null) {
              setrenderView(false);
              getClientById(clientId, soertedLIst);
            } else {
              setrenderView(true);
              setDiagnosisCodesList(
                soertedLIst.filter((codeDetails) => !codeDetails.isDeleted),
              );
              toggleLoader(false);
            }
            setMailingAddressCheckBox(false);
          } else {
            toggleLoader(false);
          }
        })
        .catch(() => {
          toggleLoader(false);
        });
    };

    handleDiagnosisDataGetAPI();
  }, []);

  React.useEffect(() => {
    if (lookups === null) {
      return;
    }
    setRaceValues(() => {
      return lookups.race.map((r) => {
        return {
          label: r.description,
          id: r.code,
        };
      });
    });
    setEthnicityValues(() => {
      return lookups.ethnicity.map((e) => {
        return {
          label: e.description,
          id: e.code,
        };
      });
    });
    setLanguageValues(() => {
      return lookups.language.map((lang) => {
        return {
          label: lang.description,
          id: lang.code,
        };
      });
    });
  }, [lookups]);

  const permissions = useMultiplePermissions([
    'backend.clients',
    'backend.in_active_referrals',
  ]);
  const referralStatus = localStorage.getItem(REFERRAL_STATUS_KEY) ?? 'None';
  const hasEditPermission =
    referralStatus === 'Inactive'
      ? permissions['backend.clients'].canEdit &&
        permissions['backend.in_active_referrals'].canEdit
      : permissions['backend.clients'].canEdit ||
        permissions['backend.in_active_referrals'].canEdit;

  React.useEffect(() => {
    if (!hasEditPermission) {
      const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Tab') {
          e.preventDefault();
        }
      };
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [hasEditPermission]);

  const validateForm = (value: ClientPageFormValues) => {
    const errors: Partial<ClientPageFormValues> = {};
    if (
      value.dateOfBirth &&
      !dayjs(clientDetails.dateOfBirth).isSame(dayjs(value.dateOfBirth))
    ) {
      if (
        dayjs(value.dateOfBirth).isBefore(
          dayjs(threeYearsAgo()).format('MM/DD/YYYY'),
        )
      ) {
        errors.dateOfBirth = 'validDate';
      }
    }
    if (
      value.visitDate &&
      dayjs(value.visitDate).isBefore(dayjs(value.dateOfBirth))
    ) {
      errors.visitDate = 'Clientpage.FirstVisitDateErrorMessage';
    }
    if (datePickerMinDateMaxDateValidate(value.dateOfBirth)) {
      errors.dateOfBirth = 'datePickerMinDateMaxDateValidate';
    }

    if (datePickerMinDateMaxDateValidate(value.visitDate)) {
      errors.visitDate = 'datePickerMinDateMaxDateValidate';
    }
    if (
      value.beginDate &&
      dayjs(value.beginDate).isBefore(dayjs(value.visitDate))
    ) {
      errors.beginDate = 'Clientpage.BeginDateErrorMessage';
    }
    return errors;
  };

  const uploadProfilePicture = (
    localStorageClientId: string,
    values: ClientPageFormValues,
  ) => {
    const file: File | null = dataURItoFile(imageSrc);
    if (file === null) {
      toggleLoader(true);
      setBtnloader(true);
      updateClient(localStorageClientId, values, false);
    } else {
      toggleLoader(true);
      setBtnloader(true);
      uploadProfilePic(localStorageClientId, file)
        .then((response) => {
          if (response) updateClient(localStorageClientId, values, false);
        })
        .finally(() => {
          setIsSubmitting(false);
        })
        .catch(async (error) => {
          formRef.current?.setValues({
            ...values,
            version: values.version,
            city: { id: 'aa', label: values.city } as OptionType,
            eCity: { id: 'aa', label: values.eCity } as OptionType,
            mCity: { id: 'aa', label: values.mCity } as OptionType,
          });

          setOpen(true);
          toggleLoader(false);
          setBtnloader(false);
          setToastrVariable('error');
          if (isCustomError(error)) {
            const apiError = error as ApiError;
            setToastrId(apiError.id);
            setToastrDefaultMessage(apiError.message);
          } else {
            setToastrId('Client.failupdate');
            setToastrDefaultMessage('Failed to update user');
          }
        });
    }
  };

  const getDisabledState = (weaponSecure: boolean | null) => {
    if (weaponSecure === null) {
      return false;
    }
    return !weaponSecure;
  };

  const formhandleSubmit = (values: ClientPageFormValues) => {
    const sexValue = values.sex ?? '';
    if (values !== null) {
      values.dateOfBirth = dayjs(values.dateOfBirth).format('MM/DD/YYYY');
    }
    values.firstName = values.firstName?.trim();
    values.middleName = values.middleName?.trim();
    values.lastName = values.lastName?.trim();
    values.sex =
      values.sex?.length === 1
        ? values.sex
        : convertGenderToBackend(sexValue) ?? null;
    values.city = (values.city as OptionType).label;
    values.eCity = (values.eCity as OptionType).label;
    if (values.mCity !== null) {
      values.mCity = (values.mCity as OptionType).label;
    }
    if (values.mothersCommunityCode) {
      values.mothersCommunityCode = (
        values.mothersCommunityCode as OptionType
      ).label;
    }
    const clientId = localStorage.getItem('ClientId');
    if (clientId !== null) {
      values.appSource = 'TCS';
      if (imageSrc === null && values.profileImageUrl !== null) {
        //remove client profile picture
        deleteProfilePicture(clientId, values);
      } else {
        uploadProfilePicture(clientId, values);
      }
    }
  };

  const deleteProfilePicture = (
    localStorageClientId: string,
    values: ClientPageFormValues,
  ) => {
    setBtnloader(true);
    deleteClientProfilePicture(localStorageClientId)
      .then(() => {
        values.profileImageUrl = '';
        updateClient(localStorageClientId, values, false);
      })
      .finally(() => {
        setIsSubmitting(false);
      })
      .catch((error) => {
        formRef.current?.setValues({
          ...values,
          version: values.version,
          city: { id: 'aa', label: values.city } as OptionType,
          eCity: { id: 'aa', label: values.eCity } as OptionType,
          mCity: { id: 'aa', label: values.mCity } as OptionType,
        });
        setOpen(true);
        toggleLoader(false);
        setBtnloader(false);
        setToastrVariable('error');
        if (isCustomError(error)) {
          const apiError = error as ApiError;
          setToastrId(apiError.id);
          setToastrDefaultMessage(apiError.message);
        } else {
          setToastrId('Client.failupdate');
          setToastrDefaultMessage('Failed to update user');
        }
      });
  };
  const updateClient = (
    localStorageClientId: string,
    values: ClientPageFormValues,
    skipSimilarClientCheck: boolean,
  ) => {
    if (!isSubmitting) {
      setIsSubmitting(true);

      updateClientdata(
        localStorageClientId,
        toAddNewClient(values),
        skipSimilarClientCheck,
      )
        .then((response) => {
          setBtnloader(false);
          toggleLoader(false);
          response.city =
            response.city === null
              ? { id: 'aa', label: '' }
              : { id: 'aa', label: response.city as string };

          response.eCity =
            response.eCity === null
              ? { id: 'aa', label: '' }
              : { id: 'aa', label: response.eCity as string };

          response.mCity =
            response.mCity === null
              ? { id: 'aa', label: '' }
              : { id: 'aa', label: response.mCity as string };
          response.mothersCommunityCode =
            response.mothersCommunityCode === null
              ? { id: 'aa', label: '' }
              : { id: 'aa', label: response.mothersCommunityCode as string };
          if (response.similarClients && response.similarClients?.length > 0) {
            setShowSimilarClientsModal(true);
            setSimilarClients(response.similarClients);
          } else {
            updateStorageDemographics(response);
            setEvalAddress(
              structuredClone({
                address1: response.eStreet,
                address2: response.eAddress2,
                city: response.eCity,
                state: response.eState,
                zipCode: response.eZipCode,
              }),
            );
            formRef.current?.setValues({
              ...values,
              profileImageUrl: response.profileImageUrl,
              version: response.version,
              sex: convertGenderToFrontend(response.sex ?? '') ?? null,
              address2: response.address2,
              city: response.city,
              eCity: response.eCity,
              mCity: response.mCity,
              state: response.state,
              eState: response.eState,
              mState: response.mState,
              zipCode: response.zipCode,
              eZipCode: values.eZipCode,
              mZipCode: values.mZipCode,
              visitDate: response.visitDate,
              beginDate: response.beginDate,
              assessmentHoursDec: response.assessmentHoursDec,
              assessmentHoursDecDisplay: formatNumberToDecimal(
                response.assessmentHoursDec,
              ),
              assessmentHrsUsedPriorProgramDec:
                response.assessmentHrsUsedPriorProgramDec,
              assessmentHrsUsedPriorProgramDecDisplay: formatNumberToDecimal(
                response.assessmentHrsUsedPriorProgramDec,
              ),
              noOfAssessmentHoursUsedDec: response.noOfAssessmentHoursUsedDec,
              noOfAssessmentHoursUsedDecDisplay: formatNumberToDecimal(
                response.noOfAssessmentHoursUsedDec,
              ),
              remainingAssessmentHoursDec: response.remainingAssessmentHoursDec,
              remainingAssessmentHoursDecDisplay: formatNumberToDecimal(
                response.remainingAssessmentHoursDec,
              ),
              rollOverDate: response.rollOverDate,
            });
            formRef.current?.resetForm({
              values: {
                ...values,
                profileImageUrl: response.profileImageUrl,
                version: response.version,
                address2: response.address2,
                city: response.city,
                eCity: response.eCity,
                mCity: response.mCity,
                state: response.state,
                eState: response.eState,
                mState: response.mState,
                zipCode: response.zipCode,
                eZipCode: values.eZipCode,
                mZipCode: values.mZipCode,
                visitDate: response.visitDate,
                beginDate: response.beginDate,
                assessmentHoursDec: response.assessmentHoursDec,
                assessmentHoursDecDisplay: formatNumberToDecimal(
                  response.assessmentHoursDec,
                ),
                assessmentHrsUsedPriorProgramDec:
                  response.assessmentHrsUsedPriorProgramDec,
                assessmentHrsUsedPriorProgramDecDisplay: formatNumberToDecimal(
                  response.assessmentHrsUsedPriorProgramDec,
                ),
                noOfAssessmentHoursUsedDec: response.noOfAssessmentHoursUsedDec,
                noOfAssessmentHoursUsedDecDisplay: formatNumberToDecimal(
                  response.noOfAssessmentHoursUsedDec,
                ),
                remainingAssessmentHoursDec:
                  response.remainingAssessmentHoursDec,
                remainingAssessmentHoursDecDisplay: formatNumberToDecimal(
                  response.remainingAssessmentHoursDec,
                ),
                rollOverDate: response.rollOverDate,
              },
            });
            setClientDetails({
              ...toAddNewClient(values),
              profileImageUrl: response.profileImageUrl,
              version: response.version,
              address2: response.address2,
              city: response.city,
              eCity: response.eCity,
              mCity: response.mCity,
              state: response.state,
              eState: response.eState,
              mState: response.mState,
              zipCode: response.zipCode,
              eZipCode: values.eZipCode,
              mZipCode: values.mZipCode,
              visitDate: response.visitDate,
              beginDate: response.beginDate,
              assessmentHoursDec: response.assessmentHoursDec,
              assessmentHrsUsedPriorProgramDec:
                response.assessmentHrsUsedPriorProgramDec,
              noOfAssessmentHoursUsedDec: response.noOfAssessmentHoursUsedDec,
              remainingAssessmentHoursDec: response.remainingAssessmentHoursDec,
              rollOverDate: response.rollOverDate,
              mothersCommunityCode: response.mothersCommunityCode,
            });
            localStorage.setItem(
              'clientName',
              formatName(
                response.firstName,
                response.middleName,
                response.lastName,
                response.suffix,
              ),
            );
            setOpen(true);
            updateData(response, 0, false);
            setToastrVariable('success');
            setToastrDefaultMessage('Client Updated Successfully!');
            setToastrId('Client.updatetoastr');
          }
        })
        .finally(() => {
          setIsSubmitting(false);
        })
        .catch((error) => {
          formRef.current?.setValues({
            ...values,
            version: values.version,
            city: { id: 'aa', label: values.city } as OptionType,
            eCity: { id: 'aa', label: values.eCity } as OptionType,
            mCity: { id: 'aa', label: values.mCity } as OptionType,
            assessmentHoursDec: values.assessmentHoursDec,
            assessmentHrsUsedPriorProgramDec:
              values.assessmentHrsUsedPriorProgramDec,
            noOfAssessmentHoursUsedDec: values.noOfAssessmentHoursUsedDec,
            remainingAssessmentHoursDec: values.remainingAssessmentHoursDec,
          });
          setOpen(true);
          toggleLoader(false);
          setBtnloader(false);
          setToastrVariable('error');
          if (isCustomError(error)) {
            const apiError = error as ApiError;
            setToastrId(apiError.id);
            setToastrDefaultMessage(apiError.message);
          } else {
            const response = error as ApiMessage;
            if (response.code === 1038) {
              setToastrId('DuplicateClientModal.header');
              setToastrDefaultMessage('This Client already exists in TCS');
            } else if (response.code === 1082) {
              setToastrId('ApiError.UnavailableRemainingHrs');
              setToastrDefaultMessage(
                'The Remaining Assessment Hours cannot be negative.',
              );
            } else if (response.code === 1084) {
              setToastrId('ApiError.DateOfBirthBeforeAssessment');
              setToastrDefaultMessage(
                'Date of Birth should be before date of assessment for all assessments of this client.',
              );
            } else if (response.code === 1085) {
              setToastrId('ApiError.AssessmentVisitDateCannotBeEmpty');
              setToastrDefaultMessage(
                'Assessment is already completed for the client. First Assessment Visit Date and Assessment Begin Date cannot be blank.',
              );
            } else if (response.code === 1086) {
              setToastrId('ApiError.AssessmentStartDateCannotUpdate');
              setToastrDefaultMessage(
                'First Assessment Visit Date and Assessment Begin Date cannot be later than the Initial Evaluation Date',
              );
            } else if (response.code === 1087) {
              setToastrId('ApiError.AssessmentVisitDateCannotBeBeforeDOB');
              setToastrDefaultMessage(
                'First Assessment Visit Date and Assessment Begin Date cannot be prior to the client’s Date of Birth.',
              );
            } else if (response.code === 1088) {
              setToastrId('ApiError.PreviousAssessmentDataExists');
              setToastrDefaultMessage(
                'As the client has completed one Roll-over Date cycle, the First Assessment Visit Date and Assessment Begin Date is now locked and cannot be altered.',
              );
            } else {
              setToastrId('Client.failupdate');
              setToastrDefaultMessage('Failed to update user');
            }
          }
        });
    }
  };

  const updateStorageDemographics = (response: AddNewClient) => {
    const demographicsDetails: FaceSheetDemographicsType = {
      firstName: response.firstName,
      middleName: response.middleName,
      lastName: response.lastName,
      suffix: response.suffix,
      ifspDueDate: dayjs(response.ifspDueDate, 'MM/DD/YYYY').format(
        'MM/DD/YYYY',
      ),
      ageInMonths: response.dateOfBirth
        ? calculateMonths(response.dateOfBirth as string)
        : null,
      diagnosis: null,
      noOfAssessmentHoursUsedDec: null,
      remainingAssessmentHoursDec: null,
      dphId: response.dphId,
      sex: response.sex,
      serviceCoordinator: null,
      serviceCoordinatorHistory: [],
      intakeCoordinator: null,
      intakeCoordinatorHistory: [],
      serviceCoordinatorStartDate: null,
      rollOverDate: null,
      beginDate: null,
      assessmentHoursDec: null,
      referralDate: null,
      referralEndDate: null,
      status: '',
      referralType: null,
      elProgram: null,
      elContactNumber: null,
      eligibilityDate: null,
      povertyLevel: null,
      dateOfBirth: dayjs(response.dateOfBirth, 'MM/DD/YYYY').format(
        'MM/DD/YYYY',
      ),
      referralId: response.referralId,
      address: {
        id: null,
        street: response.street,
        address2: response.address2,
        state: response.state,
        zipCode: response.zipCode,
        city: response.city as string,
      },
      isSecondaryProgramServices: false,
      eicsConsentToAccessInsurance: 0,
      consentToAccessStartDate: null,
      referralContact: [],
      resourceDto: null,
      appSource: response.appSource,
    };
    updateDemographics(demographicsDetails);
  };
  const getClientById = (
    clientId: string,
    filteredDiagnosisCodeList: DiagnosisOptionType[],
  ) => {
    toggleLoader(true);
    viewClientDetails(clientId)
      .then((response: AddNewClient) => {
        updateStorageDemographics(response);

        localStorage.setItem(
          'clientName',
          formatName(
            response.firstName,
            response.middleName,
            response.lastName,
            response.suffix,
          ),
        );
        response.city =
          response.city === null
            ? { id: 'aa', label: '' }
            : { id: 'aa', label: response.city as string };
        response.eCity =
          response.eCity === null
            ? { id: 'aa', label: '' }
            : { id: 'aa', label: response.eCity as string };
        response.mCity =
          response.mCity === null
            ? { id: 'aa', label: '' }
            : { id: 'aa', label: response.mCity as string };
        response.mothersCommunityCode =
          response.mothersCommunityCode === null
            ? { id: 'aa', label: '' }
            : { id: 'aa', label: response.mothersCommunityCode as string };
        response.sex = response.sex
          ? convertGenderToFrontend(response.sex)
          : null;
        setEvalAddress(
          structuredClone({
            address1: response.eStreet,
            address2: response.eAddress2,
            city: response.eCity,
            state: response.eState,
            zipCode: response.eZipCode,
          }),
        );
        setClientDetails(response);
        setrenderView(true);
        toggleLoader(false);
        updateData(response, 0, location?.state?.isCreate);
        setMailingAddressCheckBox(response.mailingAddressFlag);

        const filteredDiagnosisList: DiagnosisOptionType[] = [];
        filteredDiagnosisCodeList.forEach((codeDetails) => {
          if (codeDetails.id === response.billingDiagnosisCode) {
            filteredDiagnosisList.push(codeDetails);
          }
          if (!codeDetails.isDeleted) {
            filteredDiagnosisList.push(codeDetails);
          }
        });

        // remove duplicates in filteredDiagnosisList
        const uniqueDiagnosisList = filteredDiagnosisList.filter(
          (item, index) => {
            return filteredDiagnosisList.indexOf(item) === index;
          },
        );

        uniqueDiagnosisList.sort((a, b) => {
          if (a.id < b.id) return -1;
          if (a.id > b.id) return 1;
          return 0;
        });

        const soertedLIst = uniqueDiagnosisList;

        setDiagnosisCodesList(soertedLIst);

        const selected: OptionType | undefined = uniqueDiagnosisList.find(
          (d) => d.id === response.billingDiagnosisCode,
        );
        if (selected) setSelectedDiagnosisCodesList(selected);
      })
      .catch((error) => {
        setOpen(true);
        toggleLoader(false);
        setToastrVariable('error');
        if (isCustomError(error)) {
          const apiError = error as ApiError;
          setToastrId(apiError.id);
          setToastrDefaultMessage(apiError.message);
        } else {
          setToastrId('Client.getFailedError');
          setToastrDefaultMessage('Failed to get client details');
        }
      });
  };

  const clearForm = () => {
    formRef.current?.setValues(formRef.current?.initialValues);
    setOpenModal(false);
  };

  const navigate = useNavigate();

  const handleAddressCheckboxChange = (checked: boolean) => {
    formRef?.current?.setValues((previousValues) => ({
      ...previousValues,
      eZipCode: checked ? previousValues.zipCode : '',
      eState: checked ? previousValues.state : '',
      eCity: checked ? previousValues.city : { id: '', label: '' },
      eStreet: checked ? previousValues.street : '',
      eAddress2: checked ? previousValues.address2 : '',
      evaluationAddressFlag: checked,
    }));
  };

  React.useEffect(() => {
    if (mailingAddressCheckBox) {
      formRef.current?.setValues((values) => ({
        ...values,
        mZipCode: values.zipCode,
        mState: values.state,
        mCity: values.city,
        mStreet: values.street,
        mAddress2: values.address2,
      }));
    } else {
      formRef.current?.setValues((values) => ({
        ...values,
        mCity: { id: '', label: '' },
        mState: '',
        mZipCode: '',
        mStreet: '',
        mAddress2: '',
      }));
    }
  }, [mailingAddressCheckBox]);

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  const nameValidation = (value: string): string | undefined => {
    const trimmedValue = value?.replace(/^\s+/, '');
    const regex = /^[A-Za-z,'. -]*$/;
    if (regex.test(trimmedValue)) {
      return trimmedValue;
    }
  };

  const checkEvaluationAddressChanged = (values: ClientPageFormValues) => {
    if (
      values &&
      evalAddress &&
      values.eStreet === evalAddress.address1 &&
      values.eAddress2 === evalAddress.address2 &&
      values.eState === evalAddress.state &&
      (values.eCity as OptionType).label ===
        (evalAddress.city as OptionType).label
    ) {
      return false;
    }
    return true;
  };

  const shouldDisableDateOfBirth = (evaluationStatus: boolean | null) => {
    if (!evaluationStatus) {
      return false;
    }

    const hasPermission = checkPermissionForFeature(
      'backend.dob_after_evaluation',
      'editPermission',
    );

    return !hasPermission;
  };

  console.log(formRef.current?.errors, 'formRef.current?.errors');
  return (
    <>
      <SnackBarComponent
        open={open}
        handleClose={handleClose}
        successOrError={toastrVariable}
        labelId={toastrId}
        defaultMessageId={toastrDefaultMessage}
      />
      {isEvalAddressChanged && (
        <ModalPopup
          open={isEvalAddressChanged}
          maxWidth={'sm'}
          description="evalAddressUpdateDesc"
          onCancel={() => setIsEvalAddressChanged(false)}
          onOk={() => {
            setIsEvalAddressChanged(false);
            const formValues = formRef.current?.values;
            if (formValues) {
              formValues.isEvaluationAddressUpdated = true;
              const request = structuredClone(formValues);
              request.dobChanged =
                formRef.current?.initialValues.dateOfBirth !==
                formValues.dateOfBirth;
              request.nameChanged =
                formRef.current?.initialValues.firstName !==
                  formValues.firstName ||
                formRef.current?.initialValues.middleName !==
                  formValues.middleName ||
                formRef.current?.initialValues.lastName !== formValues.lastName;
              formhandleSubmit(request);
            }
          }}
          labelId1="cancelText"
          negativeActionLabel="Cancel"
          labelId2="AddNewSchedulerEvent.okButton"
          positiveActionLabel="Ok"
        />
      )}
      {showSimilarClientsModal && (
        <SimilarClientsUpdateModal
          showModal={showSimilarClientsModal}
          onModalClose={() => {
            setShowSimilarClientsModal(false);
          }}
          data={similarClients}
          updateClient={() => {
            const values = structuredClone(
              formRef.current?.values,
            ) as ClientPageFormValues;

            if (values !== undefined || null) {
              values.dateOfBirth = dayjs(values.dateOfBirth).format(
                'MM/DD/YYYY',
              );
            }
            const sexValue = values.sex ?? '';
            values.firstName = values.firstName?.trim();
            values.middleName = values.middleName?.trim();
            values.lastName = values.lastName?.trim();
            values.suffix = values.suffix?.trim() ?? null;
            values.sex =
              values.sex?.length === 1
                ? values.sex
                : convertGenderToBackend(sexValue) ?? null;
            values.city = (values.city as OptionType).label;
            values.eCity = (values.eCity as OptionType).label;
            if (values.mCity !== null) {
              values.mCity = (values.mCity as OptionType).label;
            }
            if (values.mothersCommunityCode) {
              values.mothersCommunityCode = (
                values.mothersCommunityCode as OptionType
              ).label;
            }
            const clientId = localStorage.getItem('ClientId');
            if (clientId !== null) {
              setShowSimilarClientsModal(false);
              toggleLoader(true);
              setBtnloader(true);
              updateClient(clientId, values, true);
            }
          }}
        />
      )}
      {renderView && (
        <Box
          ref={parentRef}
          style={{
            pointerEvents: hasEditPermission ? 'auto' : 'none',
            opacity: hasEditPermission ? 'unset' : '0.8',
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
              bgcolor: '#E7F0F0',
              padding: '0px 0px !important',
            }}
          >
            <Formik
              innerRef={formRef}
              validate={validateForm}
              initialValues={{
                id: clientDetails.id,
                firstName: clientDetails?.firstName,
                middleName: clientDetails?.middleName,
                lastName: clientDetails.lastName,
                suffix: clientDetails.suffix,
                nickName: clientDetails.nickName,
                nickNameWithheldIndicator:
                  clientDetails.nickNameWithheldIndicator,
                dateOfBirth: clientDetails.dateOfBirth
                  ? dayjs(clientDetails.dateOfBirth).format('MM/DD/YYYY')
                  : null,
                sex: clientDetails.sex,
                race: clientDetails.race.toString(),
                ethnicity: clientDetails.ethnicity,
                multipleBirth: clientDetails.multipleBirth,
                childBorn: clientDetails.childBorn,
                childAdopted: clientDetails.childAdopted,
                primaryResidence: clientDetails.primaryResidence,
                primarySpokenLanguage: clientDetails.primarySpokenLanguage,
                primarySpokenLanguageOther:
                  clientDetails.primarySpokenLanguageOther,
                primaryWrittenLanguage: clientDetails.primaryWrittenLanguage,
                primaryWrittenLanguageOther:
                  clientDetails.primaryWrittenLanguageOther,
                languageForPriorWrittenNotice:
                  clientDetails.languageForPriorWrittenNotice,
                languageForPriorWrittenNoticeOther:
                  clientDetails.languageForPriorWrittenNoticeOther,
                smokingInTheHouse: clientDetails.smokingInTheHouse,
                petsInTheHouse: clientDetails.petsInTheHouse,
                weapons: clientDetails.weapons,
                weaponSecure: clientDetails.weaponSecure,
                street: clientDetails.street,
                address2: clientDetails.address2,
                city: clientDetails.city,
                zipCode: clientDetails.zipCode,
                state: clientDetails.state,
                dphId: clientDetails.dphId,
                mailingAddressFlag: clientDetails.mailingAddressFlag,
                mStreet: clientDetails.mStreet,
                mAddress2: clientDetails.mAddress2,
                mZipCode: clientDetails.mZipCode,
                mCity: clientDetails.mCity,
                mState: clientDetails.mState,
                evaluationAddressFlag: clientDetails.evaluationAddressFlag,
                eStreet: clientDetails.eStreet,
                eAddress2: clientDetails.eAddress2,
                eZipCode: clientDetails.eZipCode,
                eCity: clientDetails.eCity,
                eState: clientDetails.eState,
                enterNote: clientDetails.enterNote,
                referralDate: clientDetails.referralDate,
                ifspDueDate: clientDetails.ifspDueDate,
                clientId: clientDetails.clientId,
                clientUuid: clientDetails.clientUuid,
                appSource: clientDetails.appSource
                  ? clientDetails.appSource
                  : '',
                version: clientDetails.version,
                referralId: clientDetails.referralId,
                assessmentHrsUsedPriorProgramDec:
                  clientDetails.assessmentHrsUsedPriorProgramDec,
                assessmentHrsUsedPriorProgramDecDisplay: formatNumberToDecimal(
                  clientDetails.assessmentHrsUsedPriorProgramDec,
                ),
                noOfAssessmentHoursUsedDec:
                  clientDetails.noOfAssessmentHoursUsedDec,
                noOfAssessmentHoursUsedDecDisplay: formatNumberToDecimal(
                  clientDetails.noOfAssessmentHoursUsedDec,
                ),
                remainingAssessmentHoursDec:
                  clientDetails.remainingAssessmentHoursDec,
                remainingAssessmentHoursDecDisplay: formatNumberToDecimal(
                  clientDetails.remainingAssessmentHoursDec,
                ),
                assessmentHoursDec: clientDetails.assessmentHoursDec,
                assessmentHoursDecDisplay: formatNumberToDecimal(
                  clientDetails.assessmentHoursDec,
                ),
                beginDate: clientDetails.beginDate,
                rollOverDate: clientDetails.rollOverDate,
                visitDate: clientDetails.visitDate,
                profileImageUrl: clientDetails.profileImageUrl,
                evaluationStatus: clientDetails.evaluationStatus,
                consentToShare: clientDetails.consentToShare,
                billingDiagnosisCode: clientDetails.billingDiagnosisCode,
                similarClients: clientDetails.similarClients,
                assessmentBeginDateUpdatedBy:
                  clientDetails.assessmentBeginDateUpdatedBy,
                dobChanged: clientDetails.dobChanged,
                nameChanged: clientDetails.nameChanged,
                mothersResidenceInMACode:
                  clientDetails.mothersResidenceInMACode,
                mothersCommunityCode: clientDetails.mothersCommunityCode,
              }}
              validateOnBlur={true}
              validateOnChange={false}
              validateOnMount={true}
              enableReinitialize={true}
              validationSchema={validationSchema}
              onSubmit={(values) => {
                if (checkEvaluationAddressChanged(values)) {
                  setIsEvalAddressChanged(true);
                } else {
                  const request = structuredClone(values);
                  request.dobChanged =
                    formRef.current?.initialValues.dateOfBirth !==
                    values.dateOfBirth;
                  request.nameChanged =
                    formRef.current?.initialValues.firstName !==
                      values.firstName ||
                    formRef.current?.initialValues.middleName !==
                      values.middleName ||
                    formRef.current?.initialValues.lastName !== values.lastName;
                  request.isEvaluationAddressUpdated = false;
                  formhandleSubmit(request);
                }
              }}
            >
              {({
                setFieldValue,
                handleSubmit,
                values,
                errors,
                touched,
                initialValues,
                handleBlur,
              }) => {
                return (
                  <Box onBlur={handleBlur}>
                    <UnsavedChangesWatcher
                      values={values}
                      initialValues={initialValues}
                      onUnsavedChangesChange={handleUpdateUnsavedChanges}
                    />
                    <Card sx={{ padding: '24px', my: '0px', ml: '0px' }}>
                      <Grid
                        container
                        rowSpacing={'24px'}
                        columnSpacing={'50px'}
                      >
                        <Grid item xs={9} lg={9}>
                          <Grid
                            container
                            rowSpacing={'24px'}
                            columnSpacing={'50px'}
                          >
                            <Grid item xs={6} lg={6}>
                              <Textinput
                                name="firstName"
                                labelid="Clientpage.First"
                                defaultlabelid="First Name"
                                Required={true}
                                inputProps={{
                                  maxLength: 40,
                                }}
                                handlechange={(value: string) => {
                                  const inputValue = value;
                                  const validatedValue =
                                    nameValidation(inputValue);
                                  if (validatedValue !== undefined) {
                                    setFieldValue('firstName', validatedValue);
                                  }
                                }}
                                Value={values.firstName}
                              />
                              {errors.firstName && touched.firstName && (
                                <MediumTypography
                                  labelid={errors.firstName}
                                  textColor="red"
                                  marginTop="8px"
                                />
                              )}
                            </Grid>
                            <Grid item xs={6} lg={6}>
                              <Textinput
                                name="middleName"
                                labelid="Clientpage.Middle"
                                defaultlabelid="Middle Name"
                                inputProps={{
                                  maxLength: 20,
                                }}
                                handlechange={(value: string) => {
                                  const inputValue = value;
                                  const validatedValue =
                                    nameValidation(inputValue);
                                  if (validatedValue !== undefined) {
                                    setFieldValue('middleName', validatedValue);
                                  }
                                }}
                                Value={values.middleName}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <Textinput
                                name="lastName"
                                inputProps={{
                                  maxLength: 40,
                                }}
                                labelid="Clientpage.Last"
                                defaultlabelid="Last Name"
                                Required={true}
                                handlechange={(value: string) => {
                                  const inputValue = value;
                                  const validatedValue =
                                    nameValidation(inputValue);
                                  if (validatedValue !== undefined) {
                                    setFieldValue('lastName', validatedValue);
                                  }
                                }}
                                Value={values.lastName}
                              />
                              {errors.lastName && touched.lastName && (
                                <MediumTypography
                                  labelid={errors.lastName}
                                  textColor="red"
                                  marginTop="8px"
                                />
                              )}
                            </Grid>

                            <Grid item xs={6}>
                              <Textinput
                                name="suffix"
                                inputProps={{
                                  maxLength: 10,
                                }}
                                labelid="AddNewReferralDetails.Suffix"
                                defaultlabelid="Suffix"
                                handlechange={(value: string) => {
                                  setFieldValue(
                                    'suffix',
                                    suffixValidation(value),
                                  );
                                }}
                                Value={values.suffix}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <Textinput
                                name="nickName"
                                inputProps={{
                                  maxLength: 30,
                                }}
                                labelid="Clientpage.Nick"
                                defaultlabelid="Nick Name"
                                handlechange={(value: string) => {
                                  const inputValue = value;
                                  const validatedValue =
                                    nameValidation(inputValue);
                                  if (validatedValue !== undefined) {
                                    setFieldValue('nickName', validatedValue);
                                  }
                                  if (inputValue.length <= 0) {
                                    setFieldValue(
                                      'nickNameWithheldIndicator',
                                      false,
                                    );
                                  }
                                }}
                                Value={values.nickName ?? ''}
                              />
                              {errors.nickName && touched.nickName && (
                                <MediumTypography
                                  labelid={errors.nickName}
                                  textColor="red"
                                  marginTop="8px"
                                />
                              )}
                            </Grid>
                            <Grid item xs={12} className="pt-none">
                              <SwitchComponent
                                toggle={values.nickNameWithheldIndicator}
                                name="nickNameWithheldIndicator"
                                labelid="Clientpage.Indicator"
                                defaultlabelid="Name Withheld Indicator"
                                handlechange={(
                                  e: React.ChangeEvent<HTMLInputElement>,
                                ) => {
                                  setFieldValue(
                                    'nickNameWithheldIndicator',
                                    e.target.checked,
                                  );
                                }}
                              />
                              {errors.nickNameWithheldIndicator &&
                                touched.nickNameWithheldIndicator && (
                                  <MediumTypography
                                    labelid={errors.nickNameWithheldIndicator}
                                    textColor="red"
                                    marginTop="0px"
                                  />
                                )}
                            </Grid>
                          </Grid>

                          <Grid
                            container
                            item
                            rowSpacing={'24px'}
                            columnSpacing={'50px'}
                          >
                            <Grid item xs={6} lg={6}>
                              <DatePickerComponent
                                name="dateOfBirth"
                                labelid="Clientpage.dateofbirth"
                                minDate={threeYearsAgo()}
                                disableFuture={true}
                                defaultlabelid="Date of Birth"
                                disabledDate={shouldDisableDateOfBirth(
                                  values.evaluationStatus,
                                )}
                                value={dayjs(values.dateOfBirth)}
                                handlechange={(datevalue: Dayjs | null) => {
                                  const formattedDate =
                                    dayjs(datevalue).format('MM/DD/YYYY');
                                  setFieldValue('referralDate', null);
                                  setFieldValue('ifspDueDate', null);
                                  if (formRef.current !== null) {
                                    if (datevalue === null) {
                                      formRef.current.setValues({
                                        ...values,
                                        dateOfBirth: null,
                                        dobChanged: false,
                                      });
                                    } else {
                                      formRef.current.setValues({
                                        ...values,
                                        dateOfBirth: formattedDate,
                                      });
                                    }
                                  }
                                }}
                              />
                              {errors.dateOfBirth && touched.dateOfBirth && (
                                <MediumTypography
                                  labelid={errors.dateOfBirth}
                                  textColor="red"
                                  marginTop="8px"
                                />
                              )}
                            </Grid>
                            <Grid item xs={6} lg={6}>
                              <SelectComponent
                                labelid="Clientpage.Sex"
                                defaultlabelid="sex"
                                name="sex"
                                value={
                                  values.sex && values.sex?.length > 1
                                    ? values.sex
                                    : convertGenderToFrontend(values.sex ?? '')
                                }
                                handleChange={(value: string) => {
                                  setFieldValue('sex', value);
                                }}
                                names={Gender}
                              />
                              {errors.sex && touched.sex && (
                                <MediumTypography
                                  labelid={errors.sex}
                                  textColor="red"
                                  marginTop="8px"
                                />
                              )}
                            </Grid>
                            <Grid item xs={6} lg={6}>
                              <MultipleAutocompleteSearch
                                labelId="Clientpage.Race"
                                defaultId="Race"
                                data={raceValues}
                                type="string"
                                onSelectItem={(value: OptionType[] | null) => {
                                  if (value) {
                                    const selectedRaceIds = value.map(
                                      (r) => r.id,
                                    );

                                    setFieldValue(
                                      'race',
                                      selectedRaceIds.toString(),
                                    );
                                  }
                                }}
                                disableLabel={true}
                                optionHintId={'No Race found'}
                                sxProps={{
                                  [`& .${autocompleteClasses.popupIndicator}`]:
                                    {
                                      transform: 'none',
                                      marginTop: '2px',
                                    },
                                  backgroundColor: '#fff',
                                }}
                                value={values.race
                                  .split(',') // Split the string by comma
                                  .map((r) => ({
                                    id: r,
                                    label:
                                      raceValues.find(
                                        (raceValue) => raceValue.id === r,
                                      )?.label ?? '', // Set label to empty string if not found
                                  }))
                                  .filter(
                                    (
                                      option,
                                    ): option is {
                                      id: string;
                                      label: string;
                                    } => option.label !== '', // Filter out options with empty labels
                                  )}
                              />
                              {errors.race && touched.race && (
                                <MediumTypography
                                  labelid={errors.race}
                                  textColor="red"
                                  marginTop="8px"
                                />
                              )}
                            </Grid>
                            <Grid item xs={6} lg={6}>
                              <DropdownComponent
                                names={ethnicityValues}
                                labelid={
                                  'IntakeFamilyHistory.EthnicityPlaceholder'
                                }
                                value={values.ethnicity}
                                defaultlabelid="Ethnicity"
                                handleChange={(e) => {
                                  setFieldValue('ethnicity', e);
                                }}
                                disabled={!hasEditPermission}
                              />
                              {errors.ethnicity && touched.ethnicity && (
                                <MediumTypography
                                  labelid={errors.ethnicity}
                                  textColor="red"
                                  marginTop="8px"
                                />
                              )}
                            </Grid>

                            <Grid item xs={4} lg={4}>
                              <DropdownComponent
                                names={languageValues}
                                labelid={'Clientpage.primarySpokenLanguage'}
                                value={values.primarySpokenLanguage}
                                defaultlabelid="Primary Spoken Language"
                                handleChange={(e) => {
                                  setFieldValue('primarySpokenLanguage', e);
                                }}
                                disabled={!hasEditPermission}
                              />
                              {errors.primarySpokenLanguage &&
                                touched.primarySpokenLanguage && (
                                  <MediumTypography
                                    labelid={errors.primarySpokenLanguage}
                                    textColor="red"
                                    marginTop="8px"
                                  />
                                )}
                            </Grid>

                            <Grid item xs={4} lg={4}>
                              <DropdownComponent
                                names={languageValues}
                                labelid={'Clientpage.PrimaryWritten'}
                                value={values.primaryWrittenLanguage}
                                defaultlabelid="Primary Written Language"
                                handleChange={(e) => {
                                  setFieldValue('primaryWrittenLanguage', e);
                                }}
                                disabled={!hasEditPermission}
                              />

                              {errors.primaryWrittenLanguage &&
                                touched.primaryWrittenLanguage && (
                                  <MediumTypography
                                    labelid={errors.primaryWrittenLanguage}
                                    textColor="red"
                                    marginTop="8px"
                                  />
                                )}
                            </Grid>

                            <Grid item xs={4} lg={4}>
                              <DropdownComponent
                                names={languageValues}
                                labelid={'Clientpage.Prior'}
                                value={values.languageForPriorWrittenNotice}
                                disabled={!hasEditPermission}
                                defaultlabelid="Language for Prior Written Notice"
                                handleChange={(e) => {
                                  setFieldValue(
                                    'languageForPriorWrittenNotice',
                                    e,
                                  );
                                }}
                              />
                              {errors.languageForPriorWrittenNotice &&
                                touched.languageForPriorWrittenNotice && (
                                  <MediumTypography
                                    labelid={
                                      errors.languageForPriorWrittenNotice
                                    }
                                    textColor="red"
                                    marginTop="8px"
                                  />
                                )}
                            </Grid>

                            <Grid
                              container
                              item
                              rowSpacing={'24px'}
                              columnSpacing={'50px'}
                            >
                              {values.primarySpokenLanguage === 'OTHER' && (
                                <Grid item xs={4} lg={4}>
                                  <Textinput
                                    name="primarySpokenLanguageOther"
                                    labelid="Clientpage.PrimaryOther"
                                    defaultlabelid="Other Spoken Language"
                                    Value={values.primarySpokenLanguageOther}
                                    handlechange={(text: string) => {
                                      setFieldValue(
                                        'primarySpokenLanguageOther',
                                        text,
                                      );
                                    }}
                                    inputProps={{ maxLength: 100 }}
                                    sxProps={{ backgroundColor: 'white' }}
                                    Required
                                  />
                                  {errors.primarySpokenLanguageOther &&
                                    touched.primarySpokenLanguageOther && (
                                      <MediumTypography
                                        labelid={
                                          errors.primarySpokenLanguageOther
                                        }
                                        defaultlabel="Is Required"
                                        className="errorText-md"
                                      />
                                    )}
                                </Grid>
                              )}

                              {values.primaryWrittenLanguage === 'OTHER' && (
                                <>
                                  {values.primarySpokenLanguage !== 'OTHER' && (
                                    <Grid item xs={4} lg={4}></Grid>
                                  )}
                                  <Grid item xs={4} lg={4}>
                                    <Textinput
                                      name="primaryWrittenLanguageOther"
                                      labelid="Clientpage.PrimaryWrittenOther"
                                      defaultlabelid="Other Written Language"
                                      Value={values.primaryWrittenLanguageOther}
                                      handlechange={(text: string) => {
                                        setFieldValue(
                                          'primaryWrittenLanguageOther',
                                          text,
                                        );
                                      }}
                                      inputProps={{ maxLength: 100 }}
                                      sxProps={{ backgroundColor: 'white' }}
                                      Required
                                    />
                                    {errors.primaryWrittenLanguageOther &&
                                      touched.primaryWrittenLanguageOther && (
                                        <MediumTypography
                                          labelid={
                                            errors.primaryWrittenLanguageOther
                                          }
                                          defaultlabel="Is Required"
                                          className="errorText-md"
                                        />
                                      )}
                                  </Grid>
                                </>
                              )}

                              {values.languageForPriorWrittenNotice ===
                                'OTHER' && (
                                <>
                                  {values.primaryWrittenLanguage !==
                                    'OTHER' && <Grid item xs={4} lg={4}></Grid>}
                                  {values.primaryWrittenLanguage !== 'OTHER' &&
                                    values.primarySpokenLanguage !==
                                      'OTHER' && (
                                      <Grid item xs={4} lg={4}></Grid>
                                    )}
                                  <Grid item xs={4} lg={4}>
                                    <Textinput
                                      name="languageForPriorWrittenNoticeOther"
                                      labelid="Clientpage.PriorOther"
                                      defaultlabelid="Other Prior Written Notice Language"
                                      Value={
                                        values.languageForPriorWrittenNoticeOther
                                      }
                                      handlechange={(text: string) => {
                                        setFieldValue(
                                          'languageForPriorWrittenNoticeOther',
                                          text,
                                        );
                                      }}
                                      inputProps={{ maxLength: 100 }}
                                      sxProps={{ backgroundColor: 'white' }}
                                      Required
                                    />

                                    {errors.languageForPriorWrittenNoticeOther &&
                                      touched.languageForPriorWrittenNoticeOther && (
                                        <MediumTypography
                                          labelid={
                                            errors.languageForPriorWrittenNoticeOther
                                          }
                                          defaultlabel="Is Required"
                                          className="errorText-md"
                                        />
                                      )}
                                  </Grid>
                                </>
                              )}
                            </Grid>

                            <Grid item xs={3} lg={3}>
                              <MediumTypography
                                labelid="Clientpage.MultipleBirth"
                                defaultlabel="Multiple Birth"
                              />
                              <CustomRadioButton
                                data={IntakeRadioData}
                                value={values.multipleBirth}
                                onSelectItem={(value) => {
                                  if (value) {
                                    setFieldValue('multipleBirth', value);
                                  }
                                }}
                              />
                              {errors.multipleBirth &&
                                touched.multipleBirth && (
                                  <MediumTypography
                                    labelid={errors.multipleBirth}
                                    textColor="red"
                                    marginTop="8px"
                                  />
                                )}
                            </Grid>
                            <Grid item xs={4} lg={4}>
                              <MediumTypography label="Was this child born in MA?" />
                              <CustomRadioButton
                                data={EICSRadioData}
                                value={values.childBorn}
                                onSelectItem={(value) => {
                                  if (value) {
                                    setFieldValue('childBorn', value);
                                  }
                                }}
                              />
                              {errors.childBorn && touched.childBorn && (
                                <MediumTypography
                                  labelid={errors.childBorn}
                                  className="errorText-md"
                                />
                              )}
                            </Grid>
                            <Grid item xs={4} lg={4}>
                              <MediumTypography label="Is this child adopted?" />
                              <CustomRadioButton
                                data={EICSRadioData}
                                value={values.childAdopted}
                                onSelectItem={(value) => {
                                  if (value) {
                                    setFieldValue('childAdopted', value);
                                  }
                                }}
                              />
                              {errors.childAdopted && touched.childAdopted && (
                                <MediumTypography
                                  labelid={errors.childAdopted}
                                  className="errorText-md"
                                />
                              )}
                            </Grid>

                            <Grid item xs={6} lg={6}>
                              <Box className="flex__">
                                <MediumTypography
                                  labelid="motherResidenceAtTimeOfChildBirthInMAQuestionText"
                                  defaultlabel="Was mother’s residence at time of child’s birth in MA?"
                                />
                                <Box
                                  className="ml-xs alignItemCenter"
                                  onMouseEnter={handlePopoverOpen}
                                  onMouseLeave={handlePopoverClose}
                                  style={{
                                    cursor: 'pointer',
                                    display: 'flex',
                                  }}
                                >
                                  <InfoIcon className="cursorPointer" />
                                  <Popover
                                    id="mouse-over-popover"
                                    sx={{
                                      pointerEvents: 'none',
                                    }}
                                    open={motherResidencePopover}
                                    anchorEl={anchorEl}
                                    anchorOrigin={{
                                      vertical: 'top',
                                      horizontal: 'center',
                                    }}
                                    transformOrigin={{
                                      vertical: 'bottom',
                                      horizontal: 'center',
                                    }}
                                    onClose={handlePopoverClose}
                                    disableRestoreFocus
                                  >
                                    <MediumTypography
                                      className="mainText-sm  p-sm"
                                      labelid="motherResidenceAtTimeOfChildBirthInMANote"
                                      defaultlabel="Select 'No / Unknown' if the mother was not in MA at the time of the child's birth, or if the location is unknown."
                                    />
                                  </Popover>
                                </Box>
                              </Box>
                              <CustomRadioButton
                                className="mt-sm"
                                data={DPHValues}
                                value={values.mothersResidenceInMACode}
                                onSelectItem={(value) => {
                                  if (value) {
                                    setFieldValue(
                                      'mothersResidenceInMACode',
                                      value,
                                    );
                                    if (value === 'NO') {
                                      setFieldValue('mothersCommunityCode', {
                                        id: '',
                                        label: '',
                                      });
                                    }
                                  }
                                }}
                              />
                              {errors.mothersResidenceInMACode &&
                                touched.mothersResidenceInMACode && (
                                  <MediumTypography
                                    labelid={errors.mothersResidenceInMACode}
                                    className="errorText-md"
                                  />
                                )}
                            </Grid>

                            {values.mothersResidenceInMACode === 'YES' && (
                              <Grid item xs={6} lg={6}>
                                <MediumTypography
                                  labelid="motherResidenceAtTimeOfChildBirthInMAText"
                                  defaultlabel="Mother’s residence at time of child’s birth?"
                                />
                                <AutocompleteSearch
                                  className="mt-sm"
                                  labelId={'Clientpage.City'}
                                  defaultId="City"
                                  selectedValue={
                                    typeof values.mothersCommunityCode ===
                                    'string'
                                      ? null
                                      : values.mothersCommunityCode
                                  }
                                  data={zipCodeOptions}
                                  freeSolo={true}
                                  type={'text'}
                                  Required={
                                    values.mothersResidenceInMACode === 'YES'
                                  }
                                  onSelectItem={(item: OptionType | null) => {
                                    if (item === null) {
                                      setFieldValue('mothersCommunityCode', {
                                        id: '',
                                        label: '',
                                      });
                                      setZipCodes([]);
                                      setZipCodeOptions([]);
                                    } else {
                                      const zipCode = zipCodes.find(
                                        (zip) => zip.zipCode === item.id,
                                      );
                                      if (zipCode) {
                                        setFieldValue('mothersCommunityCode', {
                                          id: zipCode.zipCode,
                                          label: zipCode.city,
                                        });
                                        setZipCodes([]);
                                        setZipCodeOptions([]);
                                      }
                                    }
                                  }}
                                  onTextChange={(
                                    event: React.ChangeEvent<HTMLInputElement>,
                                  ) => {
                                    changeTextDebouncer(event.target.value);
                                  }}
                                  renderOption={(props, option: OptionType) => {
                                    return (
                                      <li {...props}>
                                        <span>{option.label}</span>
                                      </li>
                                    );
                                  }}
                                  disableLabel={false}
                                  textFieldVariant="outlined"
                                />
                                {errors.mothersCommunityCode &&
                                  touched.mothersCommunityCode && (
                                    <MediumTypography
                                      labelid={
                                        (
                                          errors.mothersCommunityCode as FormikErrors<OptionType>
                                        )?.label
                                      }
                                      defaultlabel="Mother’s residence at time of child’s birth is required"
                                      className="errorText-md"
                                    />
                                  )}
                              </Grid>
                            )}

                            <Grid item xs={8} lg={8}>
                              <AutocompleteSearch
                                textDecoration={
                                  selectedDiagnosisCodesList?.label.includes(
                                    '- *',
                                  )
                                    ? 'underline'
                                    : 'none'
                                }
                                labelId={'billingDiagnosisCodeText'}
                                defaultId="Billing Diagnosis Code"
                                optionHintId={'noBillingDiagnosisCodesFound'}
                                renderOption={(props, option: OptionType) => {
                                  const parts = option.label.split(' - ');
                                  let beforeHyphen = '';
                                  let afterHyphen = '';

                                  if (parts.length > 1) {
                                    beforeHyphen = parts[0];
                                    afterHyphen = parts?.slice(1)?.join(' - ');
                                  } else {
                                    beforeHyphen = option.label;
                                  }

                                  const underlineStyle = afterHyphen.includes(
                                    '*',
                                  )
                                    ? 'underline'
                                    : 'none';

                                  return (
                                    <li {...props}>
                                      {parts.length > 1 ? (
                                        <>
                                          <span
                                            style={{ whiteSpace: 'nowrap' }}
                                          >
                                            {beforeHyphen} -{' '}
                                          </span>
                                          <Tooltip title={afterHyphen}>
                                            <span
                                              className="ellipsis_txt_profile"
                                              style={{
                                                textDecoration: underlineStyle,
                                                maxWidth: '500px',
                                              }}
                                            >
                                              {afterHyphen}
                                            </span>
                                          </Tooltip>
                                        </>
                                      ) : (
                                        <span
                                          style={{
                                            textDecoration: underlineStyle,
                                          }}
                                        >
                                          {beforeHyphen}
                                        </span>
                                      )}
                                    </li>
                                  );
                                }}
                                data={diagnosisCodesList}
                                selectedValue={selectedDiagnosisCodesList}
                                onSelectItem={(value: OptionType | null) => {
                                  if (value === null) {
                                    setSelectedDiagnosisCodesList(null);
                                    setFieldValue('billingDiagnosisCode', null);
                                  } else {
                                    setSelectedDiagnosisCodesList(value);
                                    setFieldValue(
                                      'billingDiagnosisCode',
                                      value.id,
                                    );
                                  }
                                }}
                                disableLabel={false}
                              />
                            </Grid>

                            <Grid item xs={4} lg={4}></Grid>

                            <Grid item xs={4} lg={4}>
                              <CheckBoxComponent
                                ischecked={values.consentToShare}
                                labelid="consentToShareText"
                                defaultlabelid="Consent To Share"
                                CheckHandleChange={(
                                  event: React.ChangeEvent<HTMLInputElement>,
                                ) => {
                                  setFieldValue(
                                    'consentToShare',
                                    event.target.checked,
                                  );
                                }}
                              />
                            </Grid>
                            <Grid item xs={4} lg={4}></Grid>
                            <Grid item xs={6} lg={6}>
                              <MediumTypography
                                labelid="Clientpage.AssessmentHoursText"
                                defaultlabel="Assessment Hours"
                                fontweight={600}
                                textColor="#2A4241"
                              />
                            </Grid>
                            <Grid item xs={6} lg={6}></Grid>
                            <Grid item xs={6} lg={6}>
                              <DatePickerComponent
                                value={dayjs(values.visitDate)}
                                labelid="Clientpage.FirstVisitDate"
                                defaultlabelid="First Assesment Visit Date"
                                minDate={dayjs(values.dateOfBirth)}
                                handlechange={(date: Dayjs | null) => {
                                  const formattedDate =
                                    dayjs(date).format('MM/DD/YYYY');
                                  if (date === null) {
                                    formRef.current?.setValues({
                                      ...values,
                                      visitDate: null,
                                      beginDate: null,
                                      rollOverDate: null,
                                      assessmentBeginDateUpdatedBy:
                                        initialValues.visitDate ===
                                        formattedDate
                                          ? initialValues.assessmentBeginDateUpdatedBy
                                          : 'ThomConnect',
                                    });
                                  } else {
                                    const visit = dayjs(date);
                                    let beginDate = visit;
                                    let rolloverDate = visit.add(1, 'year');
                                    const today = dayjs();

                                    while (today.isAfter(rolloverDate)) {
                                      beginDate = beginDate.add(1, 'year');
                                      rolloverDate = rolloverDate.add(
                                        1,
                                        'year',
                                      );
                                    }

                                    formRef.current?.setValues({
                                      ...values,
                                      visitDate: visit.format('MM/DD/YYYY'),
                                      beginDate: beginDate.format('MM/DD/YYYY'),
                                      rollOverDate:
                                        rolloverDate.format('MM/DD/YYYY'),
                                      assessmentBeginDateUpdatedBy:
                                        initialValues.visitDate ===
                                        date?.format('MM/DD/YYYY')
                                          ? initialValues.assessmentBeginDateUpdatedBy
                                          : 'ThomConnect',
                                    });
                                  }
                                }}
                                disabledDate={
                                  !checkPermissionForFeature(
                                    'backend.assessment_hours',
                                    'editPermission',
                                  )
                                }
                              />
                              {errors.visitDate && touched.visitDate && (
                                <MediumTypography
                                  labelid={errors.visitDate}
                                  className="errorText-md"
                                />
                              )}
                            </Grid>
                            <Grid item xs={6} lg={6}>
                              <DatePickerComponent
                                value={
                                  values.beginDate
                                    ? dayjs(values.beginDate)
                                    : null
                                }
                                labelid="ClientPage.assessmentbeginDate"
                                defaultlabelid="Assessment Begin Date"
                                handlechange={(date: Dayjs | null) => {
                                  const userId = localStorage.getItem('userId');
                                  const formattedDate =
                                    dayjs(date).format('MM/DD/YYYY');
                                  if (date === null) {
                                    formRef.current?.setValues({
                                      ...values,
                                      beginDate: null,
                                      rollOverDate: null,
                                      assessmentBeginDateUpdatedBy:
                                        initialValues.beginDate ===
                                        formattedDate
                                          ? initialValues.assessmentBeginDateUpdatedBy
                                          : userId,
                                    });
                                  } else {
                                    formRef.current?.setValues({
                                      ...values,
                                      beginDate: formattedDate,
                                      rollOverDate: dayjs(date)
                                        .add(1, 'year')
                                        .format('MM/DD/YYYY'),
                                      assessmentBeginDateUpdatedBy:
                                        initialValues.beginDate ===
                                        formattedDate
                                          ? initialValues.assessmentBeginDateUpdatedBy
                                          : userId,
                                    });
                                  }
                                }}
                                disabledDate={
                                  !checkPermissionForFeature(
                                    'backend.assessment_hours',
                                    'editPermission',
                                  )
                                }
                              />
                              {errors.beginDate && touched.beginDate && (
                                <MediumTypography
                                  labelid={errors.beginDate}
                                  className="errorText-md"
                                />
                              )}
                              {values.rollOverDate && (
                                <MediumTypography
                                  label={`${rctl.formatMessage({
                                    id: 'ClientPage.rollOverDate',
                                  })}: ${values.rollOverDate as string}`}
                                  fontweight={600}
                                  sxProps={{
                                    color: '#2A4241',
                                    fontWeight: 'bold',
                                    fontSize: '14px',
                                    mt: '4px',
                                  }}
                                />
                              )}
                            </Grid>
                            <Grid item xs={6} lg={6}>
                              <DurationPicker
                                uniqueId="assessmentHours"
                                labelId="Clientpage.startingHours"
                                defaultLabel="Starting Hours"
                                maxDuration={{ hour: 10, minutes: 0 }}
                                duration={
                                  values.assessmentHoursDec !== null
                                    ? formatToDurationFromDecimal(
                                        values.assessmentHoursDec ?? 0,
                                      )
                                    : { hour: 0, minutes: 0 }
                                }
                                required={false}
                                interval={25}
                                setDuration={(duration) => {
                                  if (
                                    duration.hour === 0 &&
                                    duration.minutes === 0
                                  ) {
                                    setFieldValue('assessmentHoursDec', null);
                                    setFieldValue(
                                      'assessmentHoursDecDisplay',
                                      '',
                                    );
                                  } else {
                                    const decimalValue =
                                      formatToDecimalFromDuration(duration);
                                    setFieldValue(
                                      'assessmentHoursDec',
                                      decimalValue,
                                    );
                                    setFieldValue(
                                      'assessmentHoursDecDisplay',
                                      decimalValue.toString(),
                                    );
                                  }
                                }}
                                disabled={
                                  !checkPermissionForFeature(
                                    'backend.assessment_hours',
                                    'editPermission',
                                  )
                                }
                              />
                              {errors.assessmentHoursDec &&
                                touched.assessmentHoursDec && (
                                  <MediumTypography
                                    labelid={errors.assessmentHoursDec}
                                    defaultlabel="Assessment hours must be between 0 and 10, in quarter-hour increments"
                                    textColor="red"
                                    marginTop="8px"
                                  />
                                )}
                            </Grid>
                            <Grid item xs={6} lg={6}>
                              <DurationPicker
                                uniqueId="assessmentHrsUsedPriorProgram"
                                labelId="Clientpage.assessmentHrsUsedPriorProgram"
                                defaultLabel="Hours Used at Prior Program"
                                maxDuration={{ hour: 10, minutes: 0 }}
                                duration={
                                  values.assessmentHrsUsedPriorProgramDec !==
                                  null
                                    ? formatToDurationFromDecimal(
                                        values.assessmentHrsUsedPriorProgramDec ??
                                          0,
                                      )
                                    : { hour: 0, minutes: 0 }
                                }
                                required={false}
                                interval={25}
                                setDuration={(duration) => {
                                  if (
                                    duration.hour === 0 &&
                                    duration.minutes === 0
                                  ) {
                                    setFieldValue(
                                      'assessmentHrsUsedPriorProgramDec',
                                      null,
                                    );
                                    setFieldValue(
                                      'assessmentHrsUsedPriorProgramDecDisplay',
                                      '',
                                    );
                                  } else {
                                    const decimalValue =
                                      formatToDecimalFromDuration(duration);
                                    setFieldValue(
                                      'assessmentHrsUsedPriorProgramDec',
                                      decimalValue,
                                    );
                                    setFieldValue(
                                      'assessmentHrsUsedPriorProgramDecDisplay',
                                      decimalValue.toString(),
                                    );
                                  }
                                }}
                                disabled={
                                  !checkPermissionForFeature(
                                    'backend.assessment_hours',
                                    'editPermission',
                                  )
                                }
                              />
                              {errors.assessmentHrsUsedPriorProgramDec &&
                                touched.assessmentHrsUsedPriorProgramDec && (
                                  <MediumTypography
                                    labelid={
                                      errors.assessmentHrsUsedPriorProgramDec
                                    }
                                    defaultlabel="Hours used at prior program must be between 0 and 10, in quarter-hour increments"
                                    textColor="red"
                                    marginTop="8px"
                                  />
                                )}
                            </Grid>
                            <Grid item xs={6} lg={6}>
                              <DurationPicker
                                uniqueId="noOfAssessmentHoursUsed"
                                labelId="Clientpage.hoursUsedSinceBeginDate"
                                defaultLabel="Hours Used Since Begin Date"
                                maxDuration={{ hour: 20, minutes: 0 }}
                                duration={
                                  values.noOfAssessmentHoursUsedDec !== null
                                    ? formatToDurationFromDecimal(
                                        values.noOfAssessmentHoursUsedDec ?? 0,
                                      )
                                    : { hour: 0, minutes: 0 }
                                }
                                required={false}
                                interval={25}
                                setDuration={() => {}}
                                disabled={true}
                              />
                            </Grid>
                            <Grid item xs={6} lg={6}>
                              <DurationPicker
                                uniqueId="remainingAssessmentHours"
                                labelId="Clientpage.remainingAssessmentHours"
                                defaultLabel="Remaining Assessment Hours"
                                maxDuration={{ hour: 20, minutes: 0 }}
                                duration={
                                  values.remainingAssessmentHoursDec !== null
                                    ? formatToDurationFromDecimal(
                                        values.remainingAssessmentHoursDec ?? 0,
                                      )
                                    : { hour: 0, minutes: 0 }
                                }
                                required={false}
                                interval={25}
                                setDuration={() => {}}
                                disabled={true}
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <MediumTypography
                                fontweight={600}
                                labelid="Clientpage.HomeSafety"
                                defaultlabel="Home Visiting Safety Risks"
                              />
                            </Grid>
                            <Grid item xs={3}>
                              <RadioComponent
                                value={values.smokingInTheHouse}
                                name="smokingInTheHouse"
                                handleChange={(
                                  e: React.ChangeEvent<HTMLInputElement>,
                                ) => {
                                  setFieldValue(
                                    'smokingInTheHouse',
                                    JSON.parse(e.target.value),
                                  );
                                }}
                                labelid="Clientpage.Smoking"
                                defaultlabelid="Smoking in the home"
                                labelidA="Clientpage.RadiolabelA"
                                defaultlabelidA="Yes"
                                labelidB="Clientpage.RadiolabelB"
                                defaultlabelidB="No"
                              />
                              {errors.smokingInTheHouse &&
                                touched.smokingInTheHouse && (
                                  <MediumTypography
                                    labelid={errors.smokingInTheHouse}
                                    textColor="red"
                                    marginTop="8px"
                                  />
                                )}
                            </Grid>
                            <Grid item xs={3}>
                              <RadioComponent
                                value={values.petsInTheHouse}
                                name="petsInTheHouse"
                                handleChange={(
                                  e: React.ChangeEvent<HTMLInputElement>,
                                ) => {
                                  setFieldValue(
                                    'petsInTheHouse',
                                    JSON.parse(e.target.value),
                                  );
                                }}
                                labelid="Clientpage.Pets"
                                defaultlabelid="Pets in the home"
                                labelidA="Clientpage.RadiolabelA"
                                defaultlabelidA="Yesss"
                                labelidB="Clientpage.RadiolabelB"
                                defaultlabelidB="Noss"
                              />
                              {errors.petsInTheHouse &&
                                touched.petsInTheHouse && (
                                  <MediumTypography
                                    labelid={errors.petsInTheHouse}
                                    textColor="red"
                                    marginTop="8px"
                                  />
                                )}
                            </Grid>
                            <Grid item xs={5}>
                              <RadioComponent
                                value={values.weapons}
                                name="weapons"
                                handleChange={(
                                  e: React.ChangeEvent<HTMLInputElement>,
                                ) => {
                                  if (formRef.current !== null) {
                                    if (!values.weapons) {
                                      setFieldValue('weaponSecure', null);
                                    }
                                    formRef.current.setValues({
                                      ...values,
                                      weapons: JSON.parse(e.target.value),
                                      weaponSecure: null,
                                    });
                                  }
                                }}
                                labelid="Clientpage.weapons"
                                defaultlabelid="Guns/Weapons/Firearms in the home"
                                labelidA="Clientpage.RadiolabelA"
                                defaultlabelidA="Yes"
                                labelidB="Clientpage.RadiolabelB"
                                defaultlabelidB="No"
                              />
                              {errors.weapons && touched.weapons && (
                                <MediumTypography
                                  labelid={errors.weapons}
                                  textColor="red"
                                  marginTop="8px"
                                />
                              )}
                            </Grid>
                            {values.weapons && (
                              <Grid item xs={12}>
                                <RadioComponent
                                  value={values.weaponSecure}
                                  name="weaponSecure"
                                  handleChange={(
                                    e: React.ChangeEvent<HTMLInputElement>,
                                  ) => {
                                    const value = JSON.parse(e.target.value);
                                    setWeaponAlert(!value);
                                    setFieldValue('weaponSecure', value);
                                    if (
                                      values.evaluationAddressFlag &&
                                      !value
                                    ) {
                                      setFieldValue(
                                        'evaluationAddressFlag',
                                        value,
                                      );
                                      setFieldValue('eZipCode', '');
                                      setFieldValue('eState', '');
                                      setFieldValue('eCity', {
                                        id: '',
                                        label: '',
                                      });
                                      setFieldValue('eStreet', '');
                                      setFieldValue('eAddress2', '');
                                    }
                                  }}
                                  labelid="Clientpage.weaponSecure"
                                  defaultlabelid="Are the weapons stored and secured"
                                  labelidA="Clientpage.RadiolabelA"
                                  defaultlabelidA="Yes"
                                  labelidB="Clientpage.RadiolabelB"
                                  defaultlabelidB="No"
                                />
                                {errors.weaponSecure &&
                                  touched.weaponSecure && (
                                    <MediumTypography
                                      labelid={errors.weaponSecure}
                                      textColor="red"
                                      marginTop="8px"
                                    />
                                  )}
                              </Grid>
                            )}
                            <Grid item xs={12}>
                              <CommentTextbox
                                maxLength={2000}
                                rows={4}
                                name="enterNote"
                                placeholder={rctl.formatMessage({
                                  id: 'CommunicationLogPage.enterNote',
                                })}
                                Required={false}
                                Value={values.enterNote}
                                handlechange={(value: string) => {
                                  setFieldValue('enterNote', value);
                                }}
                              />
                              {errors.enterNote && touched.enterNote && (
                                <MediumTypography
                                  labelid={errors.enterNote}
                                  textColor="red"
                                  marginTop="8px"
                                />
                              )}
                            </Grid>
                            <Grid item xs={12}>
                              <MediumTypography
                                fontweight={600}
                                labelid="Intake.primaryResidencePlaceholder"
                                defaultlabel="Child's primary residence"
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <DropdownComponent
                                names={primaryResidenceValues}
                                labelid={'Clientpage.primaryResidenceType'}
                                value={values.primaryResidence}
                                defaultlabelid="Primary Residence Type"
                                disabled={!hasEditPermission}
                                handleChange={(e) => {
                                  setFieldValue('primaryResidence', e);
                                }}
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <AddressForm
                                headerTitleId="Clientpage.HomeAddress"
                                address1PlaceholderId="address1Text"
                                address2PlaceholderId="address2Text"
                                zipCodePlaceholderId="Clientpage.Zip"
                                cityPlaceholderId="Clientpage.City"
                                statePlaceholderId="Clientpage.State"
                                value={{
                                  address1: values.street,
                                  address2: values.address2,
                                  zipCode: values.zipCode,
                                  city: values.city,
                                  state: values.state,
                                }}
                                isClient={true}
                                disableForm={false}
                                formRequired={true}
                                formikErrors={{
                                  address1: errors.street,
                                  address2: errors.address2,
                                  zipCode: errors.zipCode,
                                  city: errors.city,
                                  state: errors.state,
                                }}
                                formikTouched={{
                                  address1: touched.street,
                                  address2: touched.address2,
                                  zipCode: touched.zipCode,
                                  city: touched.city,
                                  state: touched.state,
                                }}
                                handleAddressUpdate={(newAddress) => {
                                  if (formRef.current !== null) {
                                    let client: ClientPageFormValues = {
                                      ...values,
                                      street: newAddress.address1,
                                      address2: newAddress.address2,
                                      zipCode: newAddress.zipCode,
                                      city: newAddress.city,
                                      state: newAddress.state,
                                    };
                                    if (values.evaluationAddressFlag) {
                                      client = {
                                        ...client,
                                        eStreet: newAddress.address1,
                                        eAddress2: newAddress.address2,
                                        eZipCode: newAddress.zipCode,
                                        eCity: newAddress.city,
                                        eState: newAddress.state,
                                      };
                                    }
                                    if (values.mailingAddressFlag) {
                                      client = {
                                        ...client,
                                        mStreet: newAddress.address1,
                                        mAddress2: newAddress.address2,
                                        mZipCode: newAddress.zipCode,
                                        mCity: newAddress.city,
                                        mState: newAddress.state,
                                      };
                                    }
                                    formRef.current.setValues(client);
                                  }
                                }}
                              />
                            </Grid>

                            <Grid item xs={12}>
                              <CheckBoxComponent
                                name="evaluationAddressFlag"
                                defaultlabelid="If Evaluation Address is same as Home Address"
                                labelid="Clientpage.ischeckedevalution"
                                ischecked={values.evaluationAddressFlag}
                                CheckHandleChange={(
                                  e: React.ChangeEvent<HTMLInputElement>,
                                ) => {
                                  handleAddressCheckboxChange(e.target.checked);
                                }}
                                disabled={getDisabledState(values.weaponSecure)}
                              />
                            </Grid>
                            <Grid container item>
                              <AddressForm
                                headerTitleId="Clientpage.EvaluationAddress"
                                address1PlaceholderId="address1Text"
                                address2PlaceholderId="address2Text"
                                zipCodePlaceholderId="Clientpage.Zip"
                                cityPlaceholderId="Clientpage.City"
                                statePlaceholderId="Clientpage.State"
                                disableForm={values.evaluationAddressFlag}
                                value={{
                                  address1: values.evaluationAddressFlag
                                    ? values.street
                                    : values.eStreet,
                                  address2: values.evaluationAddressFlag
                                    ? values.address2
                                    : values.eAddress2,
                                  city: (values.evaluationAddressFlag
                                    ? values.city
                                    : values.eCity) as OptionType,
                                  zipCode: values.evaluationAddressFlag
                                    ? values.zipCode
                                    : values.eZipCode,
                                  state: values.evaluationAddressFlag
                                    ? values.state
                                    : values.eState,
                                }}
                                isClient={true}
                                formRequired={true}
                                formikErrors={{
                                  address1: errors.eStreet,
                                  address2: errors.eAddress2,
                                  zipCode: errors.eZipCode,
                                  city: errors.eCity,
                                  state: errors.eState,
                                }}
                                formikTouched={{
                                  address1: touched.eStreet,
                                  address2: touched.eAddress2,
                                  zipCode: touched.eZipCode,
                                  city: touched.eCity,
                                  state: touched.eState,
                                }}
                                handleAddressUpdate={(newAddress) => {
                                  formRef.current?.setValues({
                                    ...values,
                                    eStreet: newAddress.address1,
                                    eAddress2: newAddress.address2,
                                    eZipCode: newAddress.zipCode,
                                    eCity: newAddress.city,
                                    eState: newAddress.state,
                                  });
                                }}
                              />
                            </Grid>
                            <Grid item xs={12}></Grid>
                          </Grid>

                          <Grid xs={12}>
                            <CheckBoxComponent
                              name="mailingAddressFlag"
                              defaultlabelid="If Mailing Address is same as Home Address"
                              labelid="Clientpage.ischecked"
                              ischecked={values.mailingAddressFlag}
                              CheckHandleChange={(
                                event: React.ChangeEvent<HTMLInputElement>,
                              ) => {
                                setFieldValue(
                                  'mailingAddressFlag',
                                  event.target.checked,
                                );
                                setClientDetails({
                                  ...clientDetails,
                                  mailingAddressFlag: event.target.checked,
                                });
                                setMailingAddressCheckBox(event.target.checked);
                              }}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <AddressForm
                              headerTitleId="Clientpage.Mailing"
                              address1PlaceholderId="address1Text"
                              address2PlaceholderId="address2Text"
                              zipCodePlaceholderId="Clientpage.Zip"
                              cityPlaceholderId="Clientpage.City"
                              statePlaceholderId="Clientpage.State"
                              disableForm={values.mailingAddressFlag}
                              formRequired={!!values.mailingAddressFlag}
                              value={{
                                address1: values.mailingAddressFlag
                                  ? values.street
                                  : values.mStreet,
                                address2: values.mailingAddressFlag
                                  ? values.address2
                                  : values.mAddress2,
                                city: (values.mailingAddressFlag
                                  ? values.city
                                  : values.mCity) as OptionType,
                                zipCode: values.mailingAddressFlag
                                  ? values.zipCode
                                  : values.mZipCode,
                                state: values.mailingAddressFlag
                                  ? values.state
                                  : values.mState,
                              }}
                              isClient={true}
                              formikErrors={{
                                address1: errors.mStreet,
                                address2: errors.mAddress2,
                                zipCode: errors.mZipCode,
                                city: errors.mCity,
                                state: errors.mState,
                              }}
                              formikTouched={{
                                address1: touched.mStreet,
                                address2: touched.mAddress2,
                                zipCode: touched.mZipCode,
                                city: touched.mCity,
                                state: touched.mState,
                              }}
                              handleAddressUpdate={(newAddress) => {
                                formRef.current?.setValues({
                                  ...values,
                                  mStreet: newAddress.address1,
                                  mAddress2: newAddress.address2,
                                  mZipCode: newAddress.zipCode,
                                  mCity: newAddress.city,
                                  mState: newAddress.state,
                                });
                              }}
                            />
                          </Grid>

                          <Grid item xs={7.5}></Grid>
                        </Grid>
                        <Grid item xs={3} lg={3} sx={{ display: 'none' }}>
                          <ImagePicker
                            config={config}
                            imageSrcProp={
                              clientDetails.profileImageUrl ?? undefined
                            }
                            imageChanged={(newDataUri: string | null) => {
                              setImageSrc(newDataUri);
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Card>
                    <Box className="mt-md mb-lg">
                      <Grid
                        className="flex__ justifyContent-FlexEnd"
                        container
                        direction="row"
                        alignItems="right"
                        visibility={hasEditPermission ? 'visible' : 'hidden'}
                      >
                        <Grid item>
                          <ButtonComponent
                            className="btn-primary btn-cancel btn_width_90px mr-md"
                            variantType="contained"
                            labelId="Clientpage.cancelbtn"
                            disabled={btnloader}
                            defaultLabelId="Cancel"
                            onClick={() => {
                              if (_.isEqual(initialValues, values)) {
                                navigate(-1);
                              } else {
                                setOpenModal(true);
                              }
                            }}
                          />
                        </Grid>
                        <Grid item>
                          <ButtonComponent
                            className="btn-primary btn-submit"
                            variantType="contained"
                            type="submit"
                            labelId={'Insurance.save'}
                            defaultLabelId="Save"
                            loading={btnloader}
                            onClick={handleSubmit}
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                );
              }}
            </Formik>
          </Box>
        </Box>
      )}
      <ModalPopup
        open={openModal}
        maxWidth={'xs'}
        description="formUnsavedChangesMessage"
        onCancel={() => setOpenModal(false)}
        onOk={() => clearForm()}
        labelId1="Clientpage.Nobtn"
        negativeActionLabel="No"
        labelId2="Clientpage.Yesbtn"
        positiveActionLabel="Yes"
      />
      <AlertDialogSlide
        open={weaponAlert}
        description="Clientpage.WeaponsAlert"
        onOk={() => setWeaponAlert(false)}
        labelId2="Clientpage.Okbtn"
        contentdescription="Clientpage.WeaponsAlertContent"
      />
    </>
  );
};
export default ClientPage;
